import createReducer from '../createReducer'
import {
  API_FAILURE_NOTIFICATION,
} from './constants'

const initialState = {
  globalError: false,
}

export default createReducer(initialState, {
  [API_FAILURE_NOTIFICATION]: (state) => {
    return { ...state, globalError: true }
  },
})
